module.exports = __webpack_public_path__ + "c8b4f33f0a228d862ee9278f882421e1.png";